import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ProductCardSkeleton from "../components/ProductCardSkeleton";
import "./AccountSkeleton.css";

export const AccountProfileSkeleton = () => (
  <div className="account-skeleton account-skeleton--profile" aria-hidden="true">
    <div className="profile-overview">
      <div className="profile-overview__hero profile-skeleton-hero">
        <div style={{ flex: 1 }}>
          <Skeleton width={140} height={14} borderRadius={4} />
          <Skeleton width="70%" height={28} borderRadius={6} style={{ marginTop: 10 }} />
          <Skeleton width="90%" height={14} borderRadius={4} style={{ marginTop: 10 }} />
        </div>
        <Skeleton circle width={72} height={72} />
      </div>

      <div className="profile-overview__stats">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="profile-stat-card">
            <Skeleton width={44} height={44} borderRadius={12} />
            <div style={{ flex: 1 }}>
              <Skeleton width={60} height={22} borderRadius={4} />
              <Skeleton width={80} height={12} borderRadius={4} style={{ marginTop: 6 }} />
            </div>
          </div>
        ))}
      </div>

      <div className="profile-overview__charts">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="profile-chart-card">
            <Skeleton width={120} height={18} borderRadius={4} />
            <Skeleton width={180} height={12} borderRadius={4} style={{ marginTop: 8 }} />
            <Skeleton height={240} borderRadius={12} style={{ marginTop: 16 }} />
          </div>
        ))}
      </div>

      <div className="profile-overview__grid">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="account-skeleton-card">
            <Skeleton height={14} width={120} borderRadius={4} />
            <Skeleton height={22} width="75%" borderRadius={6} />
            <Skeleton height={14} width="90%" borderRadius={4} />
            <Skeleton height={40} width="100%" borderRadius={999} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const AccountOrdersSkeleton = () => (
  <div className="account-skeleton account-skeleton--orders" aria-hidden="true">
    <div className="account-skeleton-tabs">
      <Skeleton height={38} width={160} borderRadius={999} />
      <Skeleton height={38} width={100} borderRadius={999} />
    </div>
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="account-skeleton-order">
        <div className="account-skeleton-order__head">
          <div>
            <Skeleton height={18} width={140} borderRadius={4} />
            <Skeleton height={12} width={90} borderRadius={4} />
          </div>
          <div className="account-skeleton-order__badges">
            <Skeleton height={26} width={72} borderRadius={999} />
            <Skeleton height={26} width={56} borderRadius={999} />
          </div>
        </div>
        <Skeleton count={2} height={12} borderRadius={4} />
        <Skeleton height={18} width={100} borderRadius={4} />
        <div className="account-skeleton-order__actions">
          <Skeleton height={34} width={72} borderRadius={999} />
          <Skeleton height={34} width={96} borderRadius={999} />
        </div>
      </div>
    ))}
  </div>
);

export const AccountGridSkeleton = ({ count = 6 }) => (
  <div className="account-skeleton account-skeleton--grid" aria-hidden="true">
    <div className="saved-products-grid">
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  </div>
);

export const AccountInboxSkeleton = () => (
  <div className="account-skeleton account-skeleton--inbox" aria-hidden="true">
    {Array.from({ length: 4 }).map((_, i) => (
      <div key={i} className="account-skeleton-inbox">
        <Skeleton height={24} width={100} borderRadius={999} />
        <Skeleton height={16} width="70%" borderRadius={4} />
        <Skeleton count={2} height={12} borderRadius={4} />
        <Skeleton height={10} width={120} borderRadius={4} />
      </div>
    ))}
  </div>
);

export const AccountReviewsSkeleton = () => (
  <div className="account-skeleton account-skeleton--reviews" aria-hidden="true">
    {Array.from({ length: 2 }).map((_, i) => (
      <div key={i} className="account-skeleton-review">
        <Skeleton width={72} height={72} borderRadius={10} />
        <Skeleton height={16} width="80%" borderRadius={4} />
        <Skeleton height={36} width="100%" borderRadius={10} />
        <Skeleton height={80} width="100%" borderRadius={10} />
        <Skeleton height={40} width={140} borderRadius={999} />
      </div>
    ))}
  </div>
);

export const AccountAddressesSkeleton = () => (
  <div className="account-skeleton account-skeleton--addresses" aria-hidden="true">
    <div className="address-list">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="account-skeleton-address">
          <Skeleton height={16} width={100} borderRadius={4} />
          <Skeleton height={14} width="85%" borderRadius={4} />
          <Skeleton height={14} width="70%" borderRadius={4} />
          <div className="account-skeleton-order__actions">
            <Skeleton height={32} width={56} borderRadius={999} />
            <Skeleton height={32} width={80} borderRadius={999} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const AccountOrderDetailSkeleton = () => (
  <div className="account-skeleton account-skeleton--order-detail" aria-hidden="true">
    <div className="order-detail-meta">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="order-detail-meta__item">
          <Skeleton height={10} width={60} borderRadius={4} />
          <Skeleton height={14} width="80%" borderRadius={4} />
        </div>
      ))}
    </div>
    <div className="account-skeleton-timeline">
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton key={i} circle width={28} height={28} />
      ))}
    </div>
    <Skeleton height={16} width={80} borderRadius={4} />
    {Array.from({ length: 3 }).map((_, i) => (
      <Skeleton key={i} height={14} width="100%" borderRadius={4} />
    ))}
  </div>
);

export const AccountSettingsSkeleton = () => (
  <div className="account-skeleton account-skeleton--settings" aria-hidden="true">
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="account-skeleton-settings-section">
        <Skeleton height={20} width={180} borderRadius={6} />
        <Skeleton height={14} width="90%" borderRadius={4} />
        <Skeleton height={44} width="100%" borderRadius={10} />
        <Skeleton height={44} width="100%" borderRadius={10} />
        <Skeleton height={40} width={160} borderRadius={999} />
      </div>
    ))}
  </div>
);

export const AccountTitleSkeleton = () => (
  <Skeleton
    className="account-skeleton-title"
    height={28}
    width={220}
    borderRadius={6}
    aria-hidden="true"
  />
);
